// this file is generated by update_shopify_store_data.py at 2026-03-18 20:31:03.195656
var courses = [
    {
        "course_id": "4FE2B233-0EC7-F011-99A1-005056A730AF",
        "course_version": 2,
        "name": "Springer Publishing - IAFN Sexual Assault Examiner (SANE-A\u00ae -- SANE-P\u00ae) Certification Online Review",
        "course_type": 1,
        "author_information": "Springer Publishing",
        "description": "Prepare for the International Association of Forensic Nurses (IAFN) Sexual Assault Examiner Adult and Pediatric (SANE-A\u00ae/SANE-P\u00ae) certification exams with a comprehensive online review aligned to the latest exam outlines. This course features learning modules with audio narration, knowledge check questions, and a practice test to strengthen test-taking skills and boost exam-day confidence. \r\n\r\nSANE-A\u00ae/SANE-P\u00ae are registered trademarks of the IAFN. The IAFN is the co-publisher for this course.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe key concepts and forensic nursing principles related to the care of sexual assault patients across the lifespan.</li>\r\n    <li>Apply critical-thinking and clinical judgment skills to adult and pediatric sexual assault patient-care scenarios.</li>\r\n    <li>Demonstrate readiness for the SANE-A&reg; and SANE-P&reg; certification exams through self-assessment activities.</li>\r\n</ul>",
        "course_outline_html": "<ul style=\"list-style-type: disc;\">\r\n    <li>Introduction</li>\r\n    <li>Module 1: Certification Exams</li>\r\n    <li>Module 2: Forensic Nursing and Sexual Assault Patients</li>\r\n    <li>Module 3: Collaborative Multidisciplinary Response to Sexual Assault</li>\r\n    <li>Module 4: Patient Responses and Crisis Intervention</li>\r\n    <li>Module 5: Medical Forensic History of the Sexual Assault Patient</li>\r\n    <li>Module 6: Physical Examination of the Patient Who Has Experienced Sexual Violence</li>\r\n    <li>Module 7: Medical Forensic Evidence Collection From the Sexual Assault Patient</li>\r\n    <li>Module 8: Medical Forensic Photography of the Sexual Assault Patient</li>\r\n    <li>Module 9: Medical Forensic Documentation</li>\r\n    <li>Module 10: Medical Management of the Sexual Assault Patient</li>\r\n    <li>Module 11: Discharge Planning</li>\r\n    <li>Module 12: Legal Issues and the Judicial Process</li>\r\n    <li>Module 13: Professional Practice Issues</li>\r\n</ul>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                "course_category_name": "Injuries",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Professional Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                "course_category_name": "All Settings",
                "is_system_course_category": null
            },
            {
                "course_category_id": "66608656-21BB-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A010654-ECD9-F011-99A4-005056A7F5E9",
                "course_category_name": "Springer Publishing - Single Courses for Purchase (NGL)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "411A8674-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Violence & Abuse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30C21A06-4DBA-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5636B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Trauma Care",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];